'use client';

// import { CustomImage as Image } from '..';
import { useTranslations } from 'next-intl';
import { useGsapContext } from 'hooks/animation/useGsapContext';
import { useRef } from 'react';
import { useIsomorphicLayoutEffect } from 'hooks/dom/useIsomorphicLayoutEffect';
import { Container } from '..';
import { PLargeGradient } from '../blood-vision/styleConstants';
import gsap from 'gsap';
import { useMasterTimeline } from 'hooks/animation/useMasterTimeline';
import { splitTextIntoSpans } from 'components/shared/SplitTextIntoSpans';
import styles from './SolidBgTextSection.module.css';
// import { useWindowSize } from 'hooks/dom/useWindowSize';

const cx = (...classes: (string | undefined)[]) =>
  classes.filter(Boolean).join(' ');

export const SolidBgTextSection = ({
  className,
  backgroundColor,
}: {
  className?: string;
  backgroundColor?: string;
}) => {
    // const { width } = useWindowSize();
    const gsapContext = useGsapContext();
    const { add } = useMasterTimeline();

    const container = useRef<HTMLDivElement>(null);

    const animationInit = () => {
      if (!container.current || !window) return;

      gsapContext.add(() => {
        const tl = gsap.timeline({
          defaults: {
            duration: 1,
            ease: 'power2.easeInOut',
          },
          scrollTrigger: {
            trigger: container.current,
            start: 'top top',
            end: 'bottom bottom',
            scrub: 0.2,
            immediateRender: false,
          },
        });

        tl.set(`.tc-1 > span`, {
          autoAlpha: 0.2,
        });

        tl.fromTo(
          '.tc-1 > span',
          {
            autoAlpha: 0.2,
          },
          {
            autoAlpha: 1,
            duration: 0.35,
            stagger: 0.2,
          },
          0.2,
        );

        // tl.to(`.tc-1 > span`, {
        //   autoAlpha: 0.2,
        //   duration: 0.35,
        // });

        // tl.fromTo(
        //   '.tc-2 > span',
        //   {
        //     autoAlpha: 0,
        //   },
        //   {
        //     autoAlpha: 0.2,
        //     duration: 0.35,
        //     stagger: 0.2,
        //   },
        //   '+=0.5',
        // );

        // tl.fromTo(
        //   '.tc-2 > span',
        //   {
        //     autoAlpha: 0.2,
        //   },
        //   {
        //     autoAlpha: 1,
        //     duration: 0.35,
        //     stagger: 0.2,
        //   },
        // );

        add(tl, 'buy-solid-bg-text');
      });
    };

    const intersectionObserver = useRef<IntersectionObserver | null>(null);

    const t = useTranslations('ring');

    useIsomorphicLayoutEffect(() => {
      intersectionObserver.current = new IntersectionObserver(
        () => {
          animationInit();
        },
        {
          root: null,
          rootMargin: '100px',
          threshold: 0,
        },
      );

      intersectionObserver.current.observe(container.current as Element);

      return () => {
        if (intersectionObserver.current) {
          intersectionObserver.current.disconnect();
        }
      };
    }, []);

    return (
      <section
        className={cx(styles.root, className)}
        ref={container}
        style={{ ['--solid-bg' as string]: backgroundColor }}
      >
        <div className={styles.stickyWrapper}>
          <Container
            style={{
              position: 'relative',
              height: '100%',
              display: 'grid',
              placeItems: 'center',
            }}
          >
            <PLargeGradient className={cx(styles.textContent, 'tc-1')}>
              {splitTextIntoSpans(t('ring.solidBgSection'))}
            </PLargeGradient>
          </Container>
        </div>
      </section>
    );
};
